import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Virginia Cannabis · Informational Hub</p>
        <h1>Your Source for Cannabis Policy and Culture in Virginia</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis laws, policies, and cultural developments in Virginia. 
          Our platform serves as a comprehensive resource for understanding the evolving landscape of cannabis in your area.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Explore Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Keep up with the latest changes in cannabis legislation and policy in Virginia. Our coverage includes 
            insights into new laws, regulatory updates, and community impacts.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Navigate the complexities of cannabis legality in Virginia. We provide clear information about what is 
            permitted and what remains prohibited under current laws.
          </p>
        </article>
        <article>
          <h2>Educational Insights</h2>
          <p>
            Access a wealth of knowledge on cannabis culture, its history, and its implications for society. 
            Our educational content aims to inform and empower the community.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;